import type { locales } from "../utils/date";

type LanguageOption = {
  label: string;
  value: keyof typeof locales;
};

// Note: Updating the available languages? Make sure to also update the
// locales array in shared/utils/date.ts to enable translation for timestamps.
export const languageOptions: LanguageOption[] = [
  {
    label: "Català (Catalan)",
    value: "ca_ES",
  },
  {
    label: "简体中文 (Chinese, Simplified)",
    value: "zh_CN",
  },
  {
    label: "繁體中文 (Chinese, Traditional)",
    value: "zh_TW",
  },
  {
    label: "Čeština (Czech)",
    value: "cs_CZ",
  },
  {
    label: "Dansk (Danish)",
    value: "da_DK",
  },
  {
    label: "Nederlands (Dutch, Netherlands)",
    value: "nl_NL",
  },
  {
    label: "English (UK)",
    value: "en_GB",
  },
  {
    label: "English (US)",
    value: "en_US",
  },
  {
    label: "Français (French)",
    value: "fr_FR",
  },
  {
    label: "Deutsch (German)",
    value: "de_DE",
  },
  {
    label: "עברית (Hebrew)",
    value: "he_IL",
  },
  {
    label: "Magyar (Hungarian)",
    value: "hu_HU",
  },
  {
    label: "Bahasa Indonesia (Indonesian)",
    value: "id_ID",
  },
  {
    label: "Italiano (Italian)",
    value: "it_IT",
  },
  {
    label: "日本語 (Japanese)",
    value: "ja_JP",
  },
  {
    label: "한국어 (Korean)",
    value: "ko_KR",
  },
  {
    label: "Norsk Bokmål (Norwegian)",
    value: "nb_NO",
  },
  {
    label: "فارسی (Persian)",
    value: "fa_IR",
  },
  {
    label: "Polski (Polish)",
    value: "pl_PL",
  },
  {
    label: "Português (Portuguese, Brazil)",
    value: "pt_BR",
  },
  {
    label: "Português (Portuguese, Portugal)",
    value: "pt_PT",
  },
  {
    label: "Español (Spanish)",
    value: "es_ES",
  },
  {
    label: "Svenska (Swedish)",
    value: "sv_SE",
  },
  {
    label: "Türkçe (Turkish)",
    value: "tr_TR",
  },
  {
    label: "Українська (Ukrainian)",
    value: "uk_UA",
  },
  {
    label: "Tiếng Việt (Vietnamese)",
    value: "vi_VN",
  },
];

export const languages = languageOptions.map((i) => i.value);
